export default __webpack_public_path__ + "1aeab5fb09c9975db77e9698ace1b48f.png";